"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_konva_1 = require("react-konva");
var use_image_1 = __importDefault(require("use-image"));
function GenericTransformer(props, ref) {
    var _a, _b, _c, _d, _e;
    var componentProps = props.componentProps, isSelected = props.isSelected, genericTransformerRef = props.genericTransformerRef, onChange = props.onChange, onSelect = props.onSelect, imageUrl = props.imageUrl;
    var image = use_image_1.default(imageUrl, "anonymous")[0];
    var shapeRef = React.useRef(null);
    var trRef = React.useRef(null);
    (_a = trRef.current) === null || _a === void 0 ? void 0 : _a.nodes([shapeRef.current]);
    (_b = trRef.current) === null || _b === void 0 ? void 0 : _b.getLayer().batchDraw();
    React.useEffect(function () {
        var _a, _b, _c, _d;
        if (isSelected || (shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current) || ((_a = componentProps === null || componentProps === void 0 ? void 0 : componentProps.text) === null || _a === void 0 ? void 0 : _a.text) ||
            componentProps.image) {
            (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.nodes([shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current]);
            (_d = (_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.getLayer()) === null || _d === void 0 ? void 0 : _d.batchDraw();
        }
    }, [isSelected, shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current, componentProps === null || componentProps === void 0 ? void 0 : componentProps.text]);
    React.useEffect(function () {
        if (image) {
            onChange(__assign(__assign({}, componentProps), { width: image.width, height: image.height }));
        }
    }, [image]);
    var isText = !!((_c = componentProps === null || componentProps === void 0 ? void 0 : componentProps.text) === null || _c === void 0 ? void 0 : _c.text);
    return (React.createElement(react_konva_1.Layer, { visible: true, draggable: false },
        React.createElement(React.Fragment, null,
            isText ? (React.createElement(react_konva_1.Text, { on: true, opacity: 0, onDragEnd: function (e) {
                    return onChange(__assign(__assign({}, componentProps), { x: e.target.x(), y: e.target.y() }));
                }, onContextMenu: function (e) {
                    e.evt.preventDefault();
                }, ref: shapeRef, draggable: true, text: (_d = componentProps === null || componentProps === void 0 ? void 0 : componentProps.text) === null || _d === void 0 ? void 0 : _d.text, fill: (_e = componentProps === null || componentProps === void 0 ? void 0 : componentProps.text) === null || _e === void 0 ? void 0 : _e.color, x: componentProps === null || componentProps === void 0 ? void 0 : componentProps.x, y: componentProps === null || componentProps === void 0 ? void 0 : componentProps.y, width: componentProps === null || componentProps === void 0 ? void 0 : componentProps.width, height: componentProps === null || componentProps === void 0 ? void 0 : componentProps.height, fontSize: componentProps === null || componentProps === void 0 ? void 0 : componentProps.fontSize, onClick: onSelect, onTap: onSelect, onTransformEnd: function (e) {
                    var node = shapeRef.current;
                    var scaleX = node.scaleX();
                    var scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    var updatedValue = __assign(__assign({}, componentProps), { x: node.x(), y: node.y(), scaleX: scaleX,
                        scaleY: scaleY, fontSize: node.fontSize() * scaleY });
                    onChange(updatedValue);
                } })) : (React.createElement(react_konva_1.Rect, __assign({ visible: true, onClick: onSelect, onTap: onSelect, ref: shapeRef, opacity: 0 }, componentProps, { draggable: true, onDragEnd: function (e) {
                    onChange(__assign(__assign({}, componentProps), { x: e.target.x(), y: e.target.y() }));
                }, onTransformEnd: function (e) {
                    var node = shapeRef.current;
                    var scaleX = node.scaleX();
                    var scaleY = node.scaleY();
                    node.scaleX(1);
                    node.scaleY(1);
                    var updatedValue = __assign(__assign({}, componentProps), { width: image ? Math.max(5, node.width() * scaleX) : undefined, height: image ? Math.max(node.height() * scaleY) : undefined, x: node.x(), y: node.y() });
                    onChange(updatedValue);
                } }))),
            isSelected && (React.createElement(react_konva_1.Transformer, { ref: ref, enabledAnchors: isText
                    ? ["top-left", "top-right", "bottom-left", "bottom-right"]
                    : [
                        "top-left",
                        "top-center",
                        "top-right",
                        "middle-right",
                        "middle-left",
                        "bottom-left",
                        "bottom-center",
                        "bottom-right"
                    ], boundBoxFunc: function (oldBox, newBox) {
                    // limit resize
                    if (newBox.width < 5 || newBox.height < 5) {
                        return oldBox;
                    }
                    return newBox;
                } })))));
}
exports.default = React.forwardRef(GenericTransformer);
